import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'dc-multisession-conflict-dialog',
    templateUrl: './multisession-conflict-dialog.component.html',
    styleUrls: ['./multisession-conflict-dialog.component.scss'],
    imports: [MatButtonModule, MatDialogModule, TranslatePipe],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultisessionConflictDialogComponent {}
